export default __webpack_public_path__ + "static/media/vlad_rusu.e758e1df.png";